import React from 'react';
import langConf from "../js/lang";

class LanguageDropdown extends React.Component {
    state ={currentLanguage: this.props.lang}
    handleSelection = (event) =>{
        this.props.changeLanguage(event.target.value);
        this.setState({currentLanguage: event.target.value});
    };

    render () {
        let lang = this.props.lang;

            return (
                <div className={`col-3 col-xs-6 choose-language ${lang==='hebrew'?'hebrew':'english'}`} style={lang === 'hebrew' ? {} : {}}>
                    <select className="selectpicker form-control" onChange={this.handleSelection} value={this.state.currentLanguage}>
                        <option value={'hebrew'}>{langConf[lang].hebrew}</option>
                        <option value={'english'}>{langConf[lang].english} </option>
                    </select>
                </div>
            );
    }
}

export default LanguageDropdown;
